// Uma mensagem é "encaminhada" quando o payload do WhatsApp traz
// `contextInfo.isForwarded` — a marca que o próprio Baileys escreve ao encaminhar
// (ver generateForwardMessageContent e a seção 4.15 do CLAUDE.md).
//
// Não existe coluna para isso: a informação já vem no `Message.json`, que o backend
// devolve inteiro para a tela. Ler daqui também faz a marca valer retroativamente,
// inclusive na mensagem que o CLIENTE encaminhou para a gente — que é o comportamento
// do WhatsApp.
//
// Mensagem NOSSA encaminhada sai com contextInfo vazio de propósito (RN01 do #14436),
// então ela cai naturalmente no `false` aqui: chega como mensagem normal.

// Envelopes que embrulham o conteúdo real (visualização única, mensagem temporária,
// documento com legenda). O contextInfo fica no conteúdo de dentro.
const ENVELOPES = [
  "ephemeralMessage",
  "viewOnceMessage",
  "viewOnceMessageV2",
  "viewOnceMessageV2Extension",
  "documentWithCaptionMessage",
];

const temMarca = (conteudo, profundidade = 0) => {
  if (!conteudo || typeof conteudo !== "object" || profundidade > 3) return false;

  for (const chave of Object.keys(conteudo)) {
    const valor = conteudo[chave];
    if (!valor || typeof valor !== "object") continue;

    if (ENVELOPES.includes(chave)) {
      if (temMarca(valor.message, profundidade + 1)) return true;
      continue;
    }

    // messageContextInfo é metadado de criptografia, não o conteúdo: nunca carrega
    // a marca, mas costuma vir junto e não custa nada ignorar explicitamente.
    if (chave === "messageContextInfo") continue;

    if (valor.contextInfo && valor.contextInfo.isForwarded) return true;
  }

  return false;
};

export const ehEncaminhada = (message) => {
  if (!message?.json) return false;
  try {
    const payload = typeof message.json === "string" ? JSON.parse(message.json) : message.json;
    return temMarca(payload?.message);
  } catch (err) {
    return false;
  }
};
